export default {
    approvals: "批准",
    delegates: "代表",
    employees: "雇员"
}